import { z } from "zod";

const systemUser = "ALFRED";
type SystemUser = typeof systemUser;
const systemUserZodSchema: z.ZodSchema<SystemUser> = z.literal(systemUser);

export { systemUser, systemUserZodSchema };
export type { SystemUser };
